<template>
  <div class="content-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'content-container'
}
</script>

<style scoped lang="scss">
.content-container {
  width: 100%;
  padding: 0 2rem;
  margin: 0 auto;

  @media (map_get($breakpoints, sm)) {
    padding-top: 0;
    max-width: 700px;
  }

  @media (map_get($breakpoints, md)) {
    max-width: 960px;
    padding-left: 285px;
    padding-right: 0;
  }

  @media (map_get($breakpoints, lg)) {
    max-width: 1240px;
  }

  @media (map_get($breakpoints, xxl)) {
    max-width: 1600px;
  }
}
</style>
